<template>
  <div style="width: 94% !important; margin-left: 3% !important">
    <v-card-text
      class="common-dropdown pa-0"
      :class="isSmallDevice ? 'small-device' : ''"
      style="min-height: 44px !important; line-height: 44px !important"
    >
      <v-col
        class="px-0 py-0"
        style="
          font-weight: bold !important;
          display: inline-flex !important;
          vertical-align: middle !important;
        "
        cols="4"
      >
        {{ labelName }}
      </v-col>
      <v-col
        class="py-0 px-0"
        @click="sheet = !sheet"
        v-if="isMobile"
        cols="8"
        style="
          display: inline-flex !important;
          vertical-align: middle !important;
        "
        :class="!isClickable ? 'unclickable' : ''"
      >
        <v-text-field
          v-model="commonSelectedValue"
          :label="!isPreselected ? itemMessage : ''"
          :rules="!notRequired ? [(v) => !!v || itemMessage] : []"
          :required="!notRequired"
          append-icon="mdi-chevron-down"
          style="font-size: 0.9rem !important"
          readonly
        ></v-text-field>
      </v-col>
      <v-col
        class="py-0 px-0 desktop-drop"
        v-if="!isMobile"
        cols="8"
        style="
          display: inline-flex !important;
          vertical-align: middle !important;
        "
      >
        <v-select
          v-model="commonSelectedValue"
          :items="items"
          :label="itemMessage"
          :rules="!notRequired ? [(v) => !!v || itemMessage] : []"
          :required="!notRequired"
          :item-value="itemKey"
          :item-text="itemText"
          :menu-props="{ bottom: true, offsetY: true }"
          append-icon="mdi-chevron-down"
          @change="handleDropdownInput"
          dense
        />
      </v-col>
      <v-bottom-sheet
        v-model="sheet"
        v-if="isMobile"
        style="max-height: 75% !important"
      >
        <v-card
          style="
            border-top-left-radius: 10px !important;
            border-top-right-radius: 10px !important;
          "
        >
          <v-subheader
            style="
              display: block !important;
              padding: 8px 16px 0 !important;
              text-align: center !important;
              height: 36px !important;
              font-weight: 500 !important;
              color: black !important;
              font-size: 1rem;
              background-color: white !important;
            "
            >{{ labelName }}
            <v-icon
              @click="sheet = false"
              style="
                color: rgba(145, 145, 145, 0.8) !important;
                position: absolute !important;
                right: 8px !important;
              "
              >mdi-close-circle-outline</v-icon
            ></v-subheader
          >
          <v-divider />
          <v-container
            style="overflow-y: auto !important; max-height: 60vh"
            class="pa-0"
          >
            <v-list>
              <template v-for="(item, i) in items">
                <v-list-item :key="i" @click="selectingValue(item)">
                  <v-list-item-title
                    style="
                      margin-left: 4%;
                      font-size: 0.85rem;
                      font-weight: 400 !important;
                    "
                    >{{
                      item[itemText] ? item[itemText] : item
                    }}</v-list-item-title
                  >
                </v-list-item>
                <v-divider
                  v-if="i < items.length - 1"
                  :key="'a' + i"
                  style="width: 90% !important; margin-left: 5% !important"
                ></v-divider>
              </template> </v-list></v-container
        ></v-card>
      </v-bottom-sheet>
    </v-card-text>
  </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
  props: {
    labelName: String,
    isClickable: Boolean,
    itemMessage: String,
    isPreselected: Boolean,
    notRequired: Boolean,
    items: Array,
    itemText: String,
    itemKey: String,
    isSmallDevice: Boolean,
    defaultValue: String,
  },
  data: () => {
    return {
      commonSelectedValue: "",
      sheet: false,
    };
  },
  mounted() {
    if (Array.isArray(this.items)) {
      if (this.defaultValue) {
        this.commonSelectedValue = this.defaultValue;
      } else if (
        (this.isPreselected && this.items.length > 0) ||
        this.items.length === 1
      ) {
        const first = this.items[0];
        if (this.itemText && this.isMobile) {
          const description = this.itemText;
          const key = this.itemKey;
          this.commonSelectedValue = first[description]
            ? first[description]
            : first.description;
          this.$emit("set-dropdown-value", first[key]);
        } else {
          this.commonSelectedValue = first;
          let returnValue;

          if (this.itemKey) {
            returnValue = first[this.itemKey];
          } else {
            returnValue = first;
          }
          this.$emit("set-dropdown-value", returnValue);
        }
      }
    } else {
      this.commonSelectedValue = "";
    }
  },
  methods: {
    handleDropdownInput() {
      if (
        this.commonSelectedValue !== "" &&
        this.commonSelectedValue !== null
      ) {
        this.$emit("set-dropdown-value", this.commonSelectedValue);
      }
    },
    selectingValue(value) {
      if (this.itemText) {
        this.commonSelectedValue = value[this.itemText];
      } else {
        this.commonSelectedValue = value;
      }
      let returnValue;
      if (this.itemKey) {
        returnValue = value[this.itemKey];
      } else {
        returnValue = value;
      }
      this.sheet = false;
      this.$emit("set-dropdown-value", returnValue);
    },
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.width < 768;
    },
  },
});
</script>

<style lang="css" scoped>
.common-dropdown >>> .v-label {
  right: 0px !important;
  left: auto !important;
  font-size: 0.85rem;
}
.desktop-drop >>> .v-label {
  right: 28px !important;
  left: auto !important;
  top: auto;
}
.desktop-drop >>> input {
  display: none !important;
}
.desktop-drop >>> .v-select__selection--comma {
  width: 100% !important;
  max-width: 100% !important;
  text-align: right;
  font-size: 0.9rem !important;
}
.common-dropdown >>> input {
  font-size: 0.85rem !important;
}
.common-dropdown >>> .v-text-field {
  padding-top: 0px !important;
  margin-top: 5px !important;
}
.common-dropdown >>> .v-text-field input {
  font-size: 0.85rem;
  text-align: right;
}
.common-dropdown >>> .v-input__slot:before {
  border-style: none !important;
}
.common-dropdown >>> .v-messages__message {
  font-size: 0.85rem;
  text-align: right;
  float: right;
  margin-right: 0 !important;
}
.common-dropdown >>> .v-input__slot:after {
  border-style: none !important;
}
.common-dropdown >>> .v-text-field .v-label--active {
  display: none !important;
}
.common-dropdown >>> .v-icon {
  color: rgb(92, 92, 92) !important;
}
.common-dropdown >>> .v-text-field__details {
  display: none !important;
}
.common-dropdown.small-device >>> * {
  font-size: 0.8rem !important;
}
.unclickable {
  pointer-events: none;
}
</style>
